import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { hasPermission, surveySchemaPermission } from 'unihow-common';

import SelectSchemaTypeDialog from '../SelectSchemaTypeDialog';
import SurveySchemaList from '../SurveySchemaList';

import styles from '../SurveySchemas.module.css';
import useTitle from '../../../hooks/useTitle';

const Schemas = ({ translate: t }) => {
  const permissions = [...useSelector((state) => state.user.currentUser.permissions)];
  const isSurveySchemaAdmin = hasPermission(permissions, surveySchemaPermission(true));
  useTitle(`${t('surveySchemas.title')} - ${t('links.surveySchemas')}`);

  return (
    <section>
      <h2 className="panel__title">{t('links.surveySchemas')}</h2>
      <p>{t('surveySchemas.schemaIntroduction')}</p>
      {isSurveySchemaAdmin && (
      <div className={styles.actions}>
        <SelectSchemaTypeDialog />
      </div>
      )}
      <SurveySchemaList />
    </section>
  );
};

const { func } = PropTypes;
Schemas.propTypes = {
  translate: func.isRequired
};

export default Schemas;
